
function ScoreBoard({score}) {

    return (<div style={{padding : '3px'}}>
        <h2> Score : {score}</h2>
    </div>);
}

export default ScoreBoard